var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"menu"},[_c('li',{staticClass:"menu__item"},[_c('router-link',{attrs:{"to":"offers"}},[_vm._v("Oferty")])],1),_c('li',{staticClass:"menu__item"},[_c('router-link',{attrs:{"to":"about"}},[_vm._v("O narzędziu")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }